import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import CustomButton from "../../../component/common/Button";
// import { Grid ,ThemeProvider} from "@material-ui/core";
import { Button, Grid, ThemeProvider, Select, Box, MenuItem,Radio, InputLabel, FormControl, Card, Typography } from "@mui/material";
import MetaAnalyticsDataAPI from "../../../../../redux/actions/api/Progress/MetaAnalytics"
import APITransport from "../../../../../redux/actions/apitransport/apitransport";
import AudioDurationChart from './AudioDurationMetaAnalyticsChart';
// import ContextualTranslationEditing from "./ContextualTranslationEditing";
// import SemanticTextualSimilarity_Scale5 from "./SemanticTextualSimilarity_Scale5";
import SingleSpeakerAudioTranscriptionEditing from "./SingleSpeakerAudioTranscriptionEditing";
// import AudioTranscription from "./AudioTranscription";
// import AudioSegmentation from "./AudioSegmentation";
import Spinner from "../../../component/common/Spinner";
import themeDefault from "../../../../theme/theme";
import LightTooltip from '../../../component/common/Tooltip';
import { translate } from "../../../../../config/localisation";
import InfoIcon from '@mui/icons-material/Info';
import { MenuProps } from "../../../../../utils/utils";
import WordCountMetaAnalyticsChart from './WordCountMetaAnalyticsChart';
import SentanceCountMetaAnalyticsChart from './SentanceCountMetaAnalyticsChart';

// Analytics responses are keyed by internal names ("MonolingualTranslation");
// the type lists in this file use display names ("Monolingual Translation").
const isOfType = (types, projectType) =>
  types.some((t) => t.replace(/\s+/g, "") === String(projectType || "").replace(/\s+/g, ""));

export default function MetaAnalytics(props) {
    const dispatch = useDispatch();
    // Rendered both with and without a loggedInUserData prop; fall back to the store.
    const storeUser = useSelector((state) => state.fetchLoggedInUserData.data);
    const loggedInUserData = props?.loggedInUserData || storeUser;
    const orgId = loggedInUserData?.organization?.id;
    const apiError = useSelector((state) => state.apiStatus.error);
    const [loading, setLoading] = useState(false);
    const apiLoading = useSelector((state) => state.apiStatus.loading);
    const [projectTypes, setProjectTypes] = useState([]);
    const [selectedType, setSelectedType] = useState("Contextual Translation Editing");
    const ProjectTypes = useSelector((state) => state.getProjectDomains.data);
    const metaAnalyticsData = useSelector(
        (state) => state.getMetaAnalyticsData.data
      );

      const getMetaAnalyticsdata = () => {
        setLoading(true);
        const userObj = new MetaAnalyticsDataAPI(orgId, selectedType);
        dispatch(APITransport(userObj));
      };

      const audioProjectTypes = [
        "Audio Transcription",
        "Audio Segmentation",
        "Audio Transcription Editing",
        "Acoustic Normalised TranscriptionEditing",
      ];
      const translationProjectTypes = [
        "Monolingual Translation",
        "Translation Editing",
        "Semantic Textual Similarity_Scale5",
        "Contextual Translation Editing",
        "Sentence Splitting",
        "Contextual Sentence Verification",
        "Contextual Sentence Verification And Domain Classification",
      ];
    
      const conversationProjectTypes = [
        "Conversation Translation",
        "Conversation Translation Editing",
        "Conversation Verification",
      ];

      const ocrProjectTypes = ["OCR Transcription Editing"];
    

      useEffect(() => {
        let types=[...audioProjectTypes,...translationProjectTypes,...conversationProjectTypes,...ocrProjectTypes,'AllTypes']
        setProjectTypes(types);
      }, []);

      useEffect(() => {
        if (orgId) getMetaAnalyticsdata();
      }, [orgId]);

      useEffect(() => {
        if (apiError) setLoading(false);
      }, [apiError]);
      const handleSubmit = async () => {
        getMetaAnalyticsdata();
      }

      useEffect(() => {
        if(metaAnalyticsData.length > 0){
          setLoading(false);

        }
      }, [metaAnalyticsData]);
  return (
    <div>
      {/* {console.log(metaAnalyticsData[0])} */}
      <Grid container columnSpacing={3} rowSpacing={2}  mb={1} gap={3}>
        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label" sx={{ fontSize: "16px" }}>
              Project Type {" "}
              {
                <LightTooltip
                  arrow
                  placement="top"
                  title={translate("tooltip.ProjectType")}>
                  <InfoIcon
                    fontSize="medium"
                  />
                </LightTooltip>
              }
            </InputLabel>

            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedType}
              label="Project Type"
              sx={{padding:"1px"}}
              onChange={(e) => setSelectedType(e.target.value)}
              MenuProps={MenuProps}
            >
              {projectTypes.map((type, index) => (
                <MenuItem value={type} key={index}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <CustomButton label="Submit" sx={{ width:"120px", mt: 3 }} onClick={handleSubmit}
              disabled={loading} />

      </Grid>
      {loading && <Spinner />}

      {metaAnalyticsData.length ?
        metaAnalyticsData.map((analyticsData,_index)=>{
          if (analyticsData.length && isOfType(audioProjectTypes, analyticsData[0].projectType)){
            return (<Grid key={_index} style={{marginTop:"15px"}}>
            <AudioDurationChart analyticsData={analyticsData}/>
            <AudioDurationChart analyticsData={analyticsData} graphCategory='rawAudioDuration'/>
            <WordCountMetaAnalyticsChart analyticsData={analyticsData} graphCategory='audioWordCount'/>
          </Grid>)}
          if(analyticsData.length && 
            (isOfType(translationProjectTypes, analyticsData[0].projectType) ||
              isOfType(conversationProjectTypes, analyticsData[0].projectType)
              )
            ){
            return <Grid key={_index} style={{marginTop:"15px"}}>
            <WordCountMetaAnalyticsChart analyticsData={analyticsData}/>
            {analyticsData[0].projectType.includes("Conversation") && <SentanceCountMetaAnalyticsChart analyticsData={analyticsData}/>}
          </Grid>
          }
        })
      :''}
    </div>
  )
}
